export const appRootAttrs = {"id":"__nuxt","tabindex":-1,"class":"outline-none has-[:modal]:overflow-hidden"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","sizes":"48x48","href":"/favicon.ico"},{"rel":"icon","type":"image/svg+xml","sizes":"any","href":"/favicon.svg"},{"rel":"manifest","href":"/manifest.webmanifest"}],"style":[],"script":[],"noscript":[{"style":"z-index: 100;position: fixed;bottom: 0;right: 24px;left: 24px;margin-bottom: 24px;margin-inline: auto;width: fit-content;max-width: 500px;display: flex;align-items: center;padding-inline: 16px;padding-block: 8px;color: #dfe2e5;background-color: #9a1302;","tagPosition":"bodyClose","textContent":"Nous sommes désolés mais Agenda.org ne fonctionne pas correctement sans JavaScript. Veuillez s'il vous plaît l'activer pour continuer."}]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false